import React from "react"
import PropTypes from "prop-types"

import BadgeExplainerModal from './BadgeExplainerModal'

class BadgeIcon extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openExplainer: false
    }

    this.openBadge = this.openBadge.bind(this)
  }

  openBadge() {
    this.setState({
      openExplainer: !this.state.openExplainer
    })
  }

  render() {
    const earnedClass = this.props.badgeEarned ? '' : ' profile-badges__badgeImg--unearned';

    return(
      <div className="profile-badges__item">
        {this.state.openExplainer === true &&
          <BadgeExplainerModal
            badge={this.props.badge}
            closeModal={this.openBadge}
            closeIcon={this.props.closeIcon}
          />
        }
        <button
          type="button"
          className="profile-badges__badgeBtn"
          onClick={this.openBadge}
          aria-label={this.props.badge.name}
        >
          <span className="profile-badges__badgeFrame">
            <img
              src={this.props.badge.image_url}
              className={`profile-badges__badgeImg${earnedClass}`}
              alt=""
            />
          </span>
        </button>
      </div>
    )
  }
}

export default BadgeIcon
